import React from 'react';
import style from '../style.module.scss';
import { CSSTransition } from 'react-transition-group';

const CalendarDrawer = (props) => {
  const { isOpen, closeDrawer } = props;

  if (isOpen) {
    return (
      <div className={style.calendar_drawer_wrap}>
        <CSSTransition
          in={isOpen}
          timeout={0}
          // classNames={props.transitionClass}
          unmountOnExit
          // appear
          onExit={closeDrawer}
        >
          {props.children}
        </CSSTransition>
      </div>
    );
  } else {
    return null;
  }
};

export default CalendarDrawer;
